<template>
  <div class="page-wrapper">
    <LoadingPlugin
      :active.sync="isLoading"
      :is-full-page="fullPage"
      background-color="#f3f3f3"
      :opacity="0.8"
      loader="bars"
    ></LoadingPlugin>

    <ConfirmModal
      :additionalMessage="true"
      :msg="$t('confrim-txt')"
      :show="showConfirm"
      @close="showConfirm = false"
      @submit="confirm"
      :insurancePlan="insurancePlan"
      :heading="$t('confirm')"
      :btnTxt="$t('yes_confirm')"
      is-yellow
      msgWidth="msg_width_dispatch"
    />

    <!-- Add Item Modal -->
    <AdditemModal
      :show="showAddItem"
      :onCancel="closeAddItem"
      @add-item="addItem"
      v-if="showAddItem"
      :item-data="item"
      @edit-item="updateEditItem"
      :currentCurrency="currency"
      :items="items"
      @update-currency="updateCurrency"
    />

    <!-- Drop off modal -->
    <add-drop-off-modal
      :show="showAddDropOff"
      :onCancel="closeAddDropOff"
      v-if="showAddDropOff"
      :dropOffData="dropOff"
      @add-dropOff="addDropOff"
      @edit-dropOff="editDropOff"
      @open-contact="openContact"
      :items="availableItems"
      :initialValues="dropOff"
    />

    <!-- Add Contact Modal -->
    <add-contact-modal
      :show="showAddContact"
      :onCancel="closeAddContact"
      @addContact="addContact"
      :items="availableItems"
      :initialValues="dropOff"
      v-if="showAddContact"
    />

    <DeviceSettingsModal
      :show="showDeviceSettings"
      :onCancel="closeShowDeviceSettings"
      v-if="showDeviceSettings"
      @add-item="submitDeviceForm"
      :selectedDevicesSettings="selectedDevicesSettings"
      :item-data="item"
      @edit-item="updateEditSettings"
    />

    <!-- Add Driver Modal -->
    <add-driver
      :show="showAddDriver"
      :onCancel="closeAddDriver"
      @add-driver="addDriver"
      v-if="showAddDriver"
      :driver="driver"
    />

    <!-- Add Vehicle -->
    <add-vehicle-modal
      :show="showAddVehicle"
      :onCancel="closeAddVehicle"
      @add-vehicle="addVehicle"
      v-if="showAddVehicle"
      :vehicle="vehicle"
    />

    <AddPartner
      v-if="addPartnerModal"
      :show="addPartnerModal"
      :onCancel="closeAddPartner"
      @partnerDetails="partnerAdded"
      :partner="partner"
    />

    <!-- Buy Insurance -->
    <insurance-popup
      v-if="showBuyInsurance"
      :show="showBuyInsurance"
      @closeBuyInsurance="closeBuyInsurance"
      @buyInsurance="buyInsurance"
    />

    <choose-insurance
      v-if="showChooseInsurance"
      :show="showChooseInsurance"
      @choose-insurance="ChooseInsurance"
      @close="closeChooseInsurance"
      :totalItemsPrice="totalItemsPrice"
    />

    <div class="page-breadcrumb">
      <div class="row">
        <div class="col-md-5 align-self-center mb-2">
          <h6 class="font-16 font-weight-bold">
            {{ $t("new_dispatch") }}
          </h6>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="card">
        <div class="card-body add-dispatch-container">
          <div class="mb-3">
            <Stepper class="custom-page" :step="step" :labels="computedLabels" />
          </div>
          <div class="d-flex align-items-center justify-content-between mb-4">
            <p
              class='font-bold'
              style="font-size: 16px;"
            >
              {{ currentStep }}
            </p>
            <div style="display: flex; align-items: center; gap: 0.7rem ">
              <div
                v-if="step === 1"
                style="border: 2px solid rgba(183, 195, 205, 1); border-radius: 8px; width: 220px;"
              >
                <select
                  class="form-control text-capitalize"
                  style="height: 40px; width: 200px; background-color: transparent !important;"
                  v-model="selectedLogisticsType"
                  id="logisticsType"
                  required
                >
                  <option
                    v-for="logisticsType in logisticsTypes"
                    :value="logisticsType"
                    :key="logisticsType"
                  >
                    {{ logisticsType }}
                  </option>
                </select>
              </div>
              <div
                class="cursor-pointer d-flex justify-content-center align-items-center"
                @click="handleAddBtn"
                v-if="showAddBtn"
              >
                <icon-circle-add class="mr-2" />
                <span class="text-primary text-capitalize">
                  {{ step === 1 ? $t("add_item") : $t("add_dropoff") }}
                </span>
              </div>
            </div>
          </div>

          <items-details-step
            :items="items"
            @showAddItemModal="openAddItem"
            @edit_item="editItem"
            @delete_item="deleteItem"
            v-if="step === 1"
          />

          <!-- <device-step
            v-if="step === 2"
            ref="deviceStep"
            :initialValues="deviceData"
          /> -->

          <pickup-details-step
            ref="pickupStep"
            v-if="step === 2 && !isDropOff"
            :initialValues="pickupData"
          />

          <drop-off-step
            v-if="step === 2 && isDropOff"
            :dropOffs="dropOffs"
            @showAddDropOffModal="showAddDropOff = true"
            @edit_dropOff="editDropOffTable"
            @delete_dropOff="dropOffs.splice($event, 1)"
            :currency="currency"
          />

          <driver-vehicle-step
            v-if="
              step === 3 && this.selectedLogisticsType === 'Internal Logistics'
            "
            ref="driverVehicleRef"
            :initialValues="vehicleDriverData"
            @open_add_driver="openAddDriver"
            :vehicleObj="vehicle"
            :driverObj="driver"
            @open_add_vehicle="openAddVehicle"
          />

          <PartnerDetailsStep
            ref="partnerDetailsRef"
            v-if="
              step === 3 && this.selectedLogisticsType === 'External Logistics'
            "
            @open_add_partner="openAddPartner"
            :partnerObj="partner"
            :initialValues="partnerData"
          />

          <insurance
            v-if="step === 4"
            :insurancePlans="insurancePlans.insurances"
            :insurancePlan="insurancePlan"
            @selected-plan="updateInsurancePlan"
          />

          <Summary
            v-if="step === 5"
            :pickupDetails="[pickupData]"
            :dropOffs="dropOffs"
            @edit_pickup="edit_pickup"
            :summaryPrices="summaryPrices"
            :dropOffTableData="dropOffTableData"
            @edit_dropOff="editDropOffTable"
            @delete_dropOff="dropOffs.splice($event, 1)"
            @edit_item="openSummaryItem"
            @delete_item="deleteSummaryItem"
            :currency="currency"
            :insurancePlan="insurancePlan"
            :productWorth="productWorth"
            :totalItemsPrice="totalItemsPrice"
          />

          <div
            class="d-flex align-items-start justify-content-end col-gap-1 pt-4"
          >
            <button class="btn btn-secondary text-capitalize" @click="goBack">
              {{ $t("back_") }}
            </button>

            <button
              @click="goNext"
              class="btn btn-primary"
              :disabled="items.length === 0 && step === 1"
            >
              {{ step === 5 ? $t("done") : $t("next") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingPlugin from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Stepper from "@/components/Stepper.vue";
import ItemsDetailsStep from "./ItemsDetailsStep.vue";
import AdditemModal from "./AdditemModal.vue";
import IconCircleAdd from "../../../components/Iconsvg/IconCircleAdd.vue";
// import DeviceStep from "./DeviceStep.vue";
import PickupDetailsStep from "./PickupDetailsStep.vue";
import AddDropOffModal from "./AddDropOffModal.vue";
import DropOffStep from "./DropOffStep.vue";
import AddContactModal from "./AddContactModal.vue";
import Summary from "./Summary.vue";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import DeviceSettingsModal from "./DeviceSettingsModal.vue";
import DriverVehicleStep from "./DriverVehicleStep.vue";
import AddDriver from "./AddDriver.vue";
import AddVehicleModal from "./AddVehicleModal.vue";
import InsurancePopup from "../../../components/Insurance/InsurancePopup.vue";
import ChooseInsurance from "../../../components/Insurance/ChooseInsurance.vue";
import Insurance from "../../../components/Insurance/Insurance.vue";
import ConfirmModal from "../../Modals/ConfirmModal.vue";

import PartnerDetailsStep from "./PartnerDetailsStep.vue";
import EditPartner from "../../Modals/EditPartner.vue";

import AddPartner from "./AddPartner.vue";

export default {
  name: "AddDispatch",
  components: {
    Stepper,
    LoadingPlugin,
    ItemsDetailsStep,
    AdditemModal,
    IconCircleAdd,
    // DeviceStep,
    PickupDetailsStep,
    AddDropOffModal,
    DropOffStep,
    AddContactModal,
    Summary,
    DeviceSettingsModal,
    DriverVehicleStep,
    AddDriver,
    AddVehicleModal,
    InsurancePopup,
    ChooseInsurance,
    Insurance,

    ConfirmModal,
    PartnerDetailsStep,
    AddPartner,
  },
  mounted() {
    this.selectedLogisticsType = this.$route.query.selectedLogisticsType || "";
    console.log(this.selectedLogisticsType);

    this.getContacts(this.params).then(() => {
      this.isLoading = false;
    });
    this.fetchallDevices();
    this.getDrivers();
    this.getVehicles();
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,
      step: 1,
      labels: [
        this.$t("item_details"),
        // this.$t("device_settings"),
        this.$t("pickup_details"),
        this.$t("driver"),
        this.$t("insurance"),
        this.$t("summary"),
      ],
      items: [],
      showAddItem: false,
      item: {},
      editIndex: null,
      // dropOffs: sampleDropOffs,
      dropOffs: [],
      isDropOff: false,
      showAddDropOff: false,
      dropOff: {},
      contact: {},
      showAddContact: false,
      deviceData: null,
      pickupData: {},
      summaryPrices: {},
      showDeviceSettings: false,
      id: null,
      selectedDevicesSettings: [],
      insurancePlans: [],
      vehicleDriverData: {},
      showAddDriver: false,
      driver: {},
      vehicle: {},
      showAddVehicle: false,
      showBuyInsurance: false,
      showChooseInsurance: false,
      insurancePlan: {
        name: "",
        price: null,
        paymentReference: null,
      },
      // paymentReference: null,
      currency: "NGN",
      productWorth: null,
      // insurancePlan: sampleInsurance,

      showConfirm: false,

      // totalProductWorth: 80000,
      // email: "user@example.com",
      selectedLogisticsType: "",
      logisticsTypes: [this.$t("internal"), this.$t("external")],

      addPartnerModal: false,

      partner: {},
      partnerData: {},
    };
  },
  computed: {
    ...mapGetters(["profile"]),

    computedLabels() {
      return this.labels.map(label => {
        if (label === this.$t("pickup_details") && this.selectedLogisticsType === this.$t("internal")) {
          return this.$t("Drop Off");
        } else if (label === this.$t("driver") && this.selectedLogisticsType === this.$t("external")) {
          return this.$t("partner");
        }
        return label;
      });
    },

    email() {
      return this.profile?.email;
    },
    showAddItemBtn() {
      return this.step === 1 && this.items.length > 0;
    },
    showAddDropOffBtn() {
      return this.step === 2 && this.isDropOff && this.dropOffs.length > 0;
    },
    showAddBtn() {
      return this.showAddItemBtn || this.showAddDropOffBtn;
    },
    currentStep() {
      let stepTitle = "";
      if (this.step === 1) {
        stepTitle = this.$t("item_details");
        // } else if (this.step === 2) {
        //   stepTitle = this.$t("device_settings");
      } else if (this.step === 2 && !this.isDropOff) {
        stepTitle = this.$t("pickup_deets");
      } else if (this.step === 2 && this.isDropOff) {
        stepTitle = this.$t("dropoff_details");
      } else if (
        this.step === 3 &&
        this.selectedLogisticsType === "Internal Logistics"
      ) {
        stepTitle = this.$t("assign-driver");
      } else if (
        this.step === 3 &&
        this.selectedLogisticsType === "External Logistics"
      ) {
        stepTitle =  this.$t("assign-partner");
      } else if (this.step === 4) {
        stepTitle = this.$t("insurance");
      } else if (this.step === 5) {
        stepTitle = this.$t("summary");
      }

      return stepTitle;
    },
    availableItems() {
      const dropOffItems = this.dropOffs.reduce((acc, dropOff) => {
        return acc.concat(dropOff.items);
      }, []);

      return this.items.filter((item) => {
        return !dropOffItems.some(
          (dropOffItem) => dropOffItem.name === item.name
        );
      });
    },
    transformedDropOffs() {
      // return this.dropOffs.flatMap((dropOff) => {
      // return this.dropOffs.map((dropOff) => {
      //   return {
      //     items: dropOff.items,
      //     contact: dropOff.contact.id ? undefined : dropOff.contact,
      //     contactId: dropOff.contact.id || undefined,
      //   };
      // });
      // });

      return this.dropOffs;
    },

    // Data for payload
    dropOffPayload() {
      const selectedLogisticsTypeText =
        this.selectedLogisticsType === "Internal Logistics"
          ? "internal"
          : "external";

      // const { device, ...rest } = this.deviceData;
      const { phoneNumber, ...pickupDetails } = this.pickupData;
      // const formattedData = this.transformedDropOffs.map(
      //   ({ item, contactId, contact }) => {
      //     const newObject = {
      //       item: {
      //         ...item,
      //         deliveryDate: moment(item.deliveryDate).toISOString(),
      //       },
      //     };
      //     if (contactId) {
      //       newObject.contactId = contactId;
      //     } else {
      //       newObject.contact = contact;
      //     }
      //     return newObject;
      //   }
      // );
      const payload = {
        // dataLogger: device,
        // dataLoggerSettings: rest,
        pickup:
          Object.keys(pickupDetails).length > 0
            ? {
                phone: phoneNumber,
                ...pickupDetails,
              }
            : undefined,
        dropoffs: this.transformedDropOffs.map(({ items, contact }) => {
          return {
            items: items.map((item) => {
              return {
                ...item,
                deliveryDate: moment(item.deliveryDate).toISOString(),
                dataLogger: item.dataLogger.id,
                price: item.price ? item.price : undefined,
                weight: item.weight ? item.weight : undefined,
                quantity: item.quantity ? item.quantity : undefined,
                weightUOM: item.weight ? item.weightUOM : undefined,
                logisticsType: selectedLogisticsTypeText
                  ? selectedLogisticsTypeText
                  : undefined,
              };
            }),

            contact: contact.id ? undefined : contact,
            contactId: contact.id || undefined,
          };
        }),

        currency: this.currency,
        insurancePlan: this.insurancePlan.plan
          ? {
              name: this.insurancePlan.keyValue,
              paymentReference: this.insurancePlan.paymentReference,
            }
          : undefined,
        driverId:
          this.vehicleDriverData?.driver === "orderDriver"
            ? undefined
            : this.vehicleDriverData?.driver,
        driver:
          this.vehicleDriverData?.driver === "orderDriver"
            ? this.driver
            : undefined,
        vehicleId:
          this.vehicleDriverData?.vehicle === "orderVehicle"
            ? undefined
            : this.vehicleDriverData?.vehicle,
        vehicle:
          this.vehicleDriverData?.vehicle === "orderVehicle"
            ? this.vehicle
            : undefined,
        totalProductWorth: this.totalItemsPrice || undefined,
        partnerId:
          this.partnerData?.partner === "newPartner"
            ? undefined
            : this.partnerData?.partner,
        partner:
          this.partnerData?.partner === "newPartner"
            ? this.partner
            : undefined,
      };
      return payload;
    },

    // Data for table
    dropOffTableData() {
      return this.transformedDropOffs.map(({ items, contact }) => {
        return {
          items,
          contact,
        };
      });
    },
    totalItemsPrice() {
      return this.items.reduce((acc, item) => {
        return acc + item.price * item.quantity;
      }, 0);
    },
    showPickup() {
      return this.items.some((item) => item.logisticsType !== "internal");
    },
    canEnterProductWorth() {
      return !this.items.some((item) => item.price);
    },
  },
  methods: {
    ...mapActions([
      "getContacts",
      "addOrder",
      "validateOrder",
      "fetchallDevices",
      "fetchInsurancePlans",
      "getDrivers",
      "getVehicles",
    ]),
    updateSettings(settings) {
      const { dataLogger, dataLoggerSettings } = settings;
      if (
        this.selectedDevicesSettings.some(
          (device) => device.dataLogger.id === settings.dataLogger.id
        )
      ) {
        const newDeviceSettingsIndex = this.selectedDevicesSettings.findIndex(
          (device) => device.dataLogger.id === settings.dataLogger.id
        );
        this.$set(this.selectedDevicesSettings, newDeviceSettingsIndex, {
          dataLogger,
          ...dataLoggerSettings,
        });
        return;
      } else {
        this.selectedDevicesSettings.push({
          dataLogger,
          ...dataLoggerSettings,
        });
      }
    },
    submitDeviceForm(settings) {
      this.item = {
        ...this.item,
        ...settings,
      };
      this.items.push(this.item);
      this.updateSettings(settings);
      this.closeShowDeviceSettings();
    },

    goBack() {
      if (this.step === 1) return this.$router.push("/dispatch/overview");
      if (this.step === 5 && !this.insurancePlan.plan) {
        return (this.step = 3);
      }

      if (
        this.step === 2 &&
        this.isDropOff &&
        this.selectedLogisticsType === "External Logistics"
      ) {
        this.isDropOff = false;
      } else {
        this.step = this.step - 1;
      }
    },
    goNext() {
      if (this.step === 4 && this.insurancePlan.plan)
        return (this.showConfirm = true);

      if (this.step === 5) {
        return this.confirmOrder();
      } else if (this.step === 1) {
        // const isValid = this.$refs.deviceStep.validateForm();
        // if (isValid) {
        //   this.deviceData = this.$refs.deviceStep.getFormData();
        //   // this.step += 1;
        // }
        this.isDropOff = false;
        this.showDeviceSettings = false;

        if (this.selectedLogisticsType === "Internal Logistics") {
          this.isDropOff = true;
          this.pickupData = {};
          this.partnerData={}
        }
        this.step += 1;
      } else if (this.step === 2 && !this.isDropOff) {
        const isValid = this.$refs.pickupStep.validateForm();
        if (isValid) {
          this.pickupData = this.$refs.pickupStep.getFormData();
          this.isDropOff = true;
        }
      } else if (this.step === 3) {
        if (this.$refs.driverVehicleRef) {
          const isValidDriver = this.$refs.driverVehicleRef.validateForm(); // Validate driver form
          if (isValidDriver) {
            this.vehicleDriverData = this.$refs.driverVehicleRef.getFormData(); // Get driver data
            this.step += 1;
            this.showBuyInsurance = true;
          }
        } else if (this.$refs.partnerDetailsRef) {
          const isValidPartner = this.$refs.partnerDetailsRef.validateForm(); // Validate partner form
          if (isValidPartner) {
            this.partnerData = this.$refs.partnerDetailsRef.getFormData(); // Get partner data
            this.step += 1;
            this.showBuyInsurance = true;
          }
        }
      } else {
        this.step += 1;
      }
      if (this.step === 5) {
        console.log("step 5");
        this.doValidaOrder();
      }
    },
    confirm() {
      const amount = this.insurancePlan.amount;

      // Call openPaystack with the necessary data
      this.openPaystack(this.email, amount);
    },
    openPaystack(email, amount) {
      const proceed = (response) => {
        console.log("Payment successful, reference:", response.reference);

        this.insurancePlan.paymentReference = response.reference;

        console.log("payment reference", this.paymentReference);

        // Proceeds to the next step after payment
        this.showConfirm = false;
        this.doValidaOrder();
        this.step += 1;
        console.log("Go to step", this.step);
      };
      // paystack key
      let key = "";
      if (window.location.host === "enterprise.gricd.com") {
        key = process.env.VUE_APP_LIVEKEY;
      } else {
        key = process.env.VUE_APP_TESTKEY;
      }

      let handler = PaystackPop.setup({
        key: key,
        email: email,
        amount: amount * 100,
        ref: "" + Math.floor(Math.random() * 1000000000 + 1),
        onClose: function() {
          console.log("Payment window closed.");
        },
        callback: function(response) {
          proceed(response);
        },
      });
      handler.openIframe();
    },

    goStep(step) {
      this.step = step;
    },
    addItem(item) {
      const id = this.items.length + 1;
      this.item = { ...item, id };
      // this.items.push({ ...item, id });
      this.showAddItem = false;
      this.showDeviceSettings = true;
      this.id = id;
    },
    closeAddItem() {
      this.showAddItem = false;
      this.id = null;
      this.item = {};
    },
    openAddItem() {
      this.showAddItem = true;
    },
    editItem(item) {
      this.showAddItem = true;
      this.item = { ...this.item, ...item };
    },
    deleteItem(index) {
      this.items.splice(index, 1);
    },
    updateEditItem(item) {
      this.item = { ...this.item, ...item };
      this.showAddItem = false;
      this.showDeviceSettings = true;
    },
    updateEditSettings(item) {
      // console.log(item);
      // console.log(this.item);

      const newItem = { ...this.item, ...item };
      this.$set(this.items, this.item.id - 1, newItem);
      this.updateSettings(item);
      this.item = {};
      this.showDeviceSettings = false;
      this.editIndex = null;
    },
    handleAddBtn() {
      if (this.showAddItemBtn) {
        this.openAddItem();
      }
      if (this.showAddDropOffBtn) {
        this.showAddDropOff = true;
      }
    },
    addDropOff(dropOff) {
      if (
        this.dropOffs.some((drop) => drop.contact.id === dropOff.contact.id)
      ) {
        this.dropOffs = this.dropOffs.map((drop) => {
          if (drop.contact.id === dropOff.contact.id) {
            return {
              ...drop,
              items: drop.items.concat(dropOff.items),
            };
          }
          return drop;
        });
        this.showAddDropOff = false;
        this.dropOff = {};
        return;
      }

      this.dropOffs.push(dropOff);
      this.showAddDropOff = false;
      this.dropOff = {};
    },
    editDropOff(dropOff) {
      this.$set(this.dropOffs, this.editIndex, dropOff);
      this.showAddDropOff = false;
      this.editIndex = null;
      this.dropOff = {};
    },
    closeAddDropOff() {
      this.showAddDropOff = false;
      this.dropOff = {};
    },
    closeAddContact() {
      this.showAddContact = false;
      this.dropOff = {};
    },
    addContact(payload) {
      if (this.editIndex !== null) {
        this.$set(this.dropOffs, this.editIndex, payload);
        this.editIndex = null;
        this.showAddContact = false;
        this.dropOff = {};
        return;
      }
      this.dropOffs.push(payload);
      this.showAddContact = false;
      this.dropOff = {};
    },
    editDropOffTable(data, index) {
      this.dropOff = data;
      this.editIndex = index;
      if (data.contact.id) {
        this.showAddDropOff = true;
      } else {
        this.showAddContact = true;
      }
    },
    openContact() {
      this.showAddContact = true;
      this.showAddDropOff = false;
    },
    edit_pickup(data) {
      this.pickupData = data;
      this.isDropOff = false;
      this.step = 2;
    },
    confirmOrder() {
      this.isLoading = true;
      this.addOrder(this.dropOffPayload)
        .then(() => {
          this.isLoading = false;
          this.$router.push(`/dispatch/overview`);
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    openSummaryItem(selectedItem) {
      const foundIndex = this.items.findIndex(
        (item) => item.name === selectedItem.name
      );
      if (foundIndex !== -1) {
        this.item = this.items[foundIndex];
        this.editIndex = foundIndex;
        this.showAddItem = true;
      }
    },
    deleteSummaryItem(selectedItem) {
      this.dropOffs.forEach((dropOff) => {
        const itemIndex = dropOff.items.findIndex(
          (dropOffItem) => dropOffItem.id === selectedItem.id
        );
        if (itemIndex !== -1) {
          this.$delete(dropOff.items, itemIndex);
        }
      });
    },
    doValidaOrder() {
      this.isLoading = true;
      this.validateOrder(this.dropOffPayload)
        .then((res) => {
          this.summaryPrices = res.data.payload;
          this.isLoading = false;
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
        });
    },
    closeShowDeviceSettings() {
      this.showDeviceSettings = false;
      this.id = null;
      this.item = {};
    },
    openAddDriver() {
      this.showAddDriver = true;
    },
    closeAddDriver() {
      this.showAddDriver = false;
    },
    addDriver(data) {
      this.driver = data;
      this.showAddDriver = false;
      // this.step += 1;
    },
    openAddVehicle() {
      this.showAddVehicle = true;
    },
    closeAddVehicle() {
      this.showAddVehicle = false;
    },
    addVehicle(data) {
      this.vehicle = data;
      this.showAddVehicle = false;
    },
    closeBuyInsurance() {
      this.showBuyInsurance = false;
      this.showConfirm = false;

      this.insurancePlan = {
        name: "",
        price: null,
      };
      this.goNext();
    },
    buyInsurance() {
      this.showBuyInsurance = false;
      // if (this.canEnterProductWorth) this.showChooseInsurance = true;
      this.showChooseInsurance = true;
    },
    closeChooseInsurance() {
      this.showChooseInsurance = false;
    },
    ChooseInsurance(productWorth) {
      this.showChooseInsurance = false;
      this.productWorth = productWorth;

      this.isLoading = true;
      // Fetches insurance plans based on the updated productWorth
      this.fetchInsurancePlans(this.productWorth)
        .then((res) => {
          if (res && res.data && res.data.success) {
            // Updates insurancePlans with the fetched data
            this.insurancePlans = res.data.payload;
            // Optionally sets the default insurance plan from the updated list
            this.insurancePlan = this.insurancePlans.insurances[0] || null;
            this.isLoading = false;
          } else {
            console.error("Failed to fetch insurance plans:", res.data.message);
          }
        })
        .catch((error) => {
          console.error("Error fetching insurance plans:", error);
        });
    },

    updateInsurancePlan(plan) {
      this.insurancePlan = plan;
    },
    updateCurrency(currency) {
      this.currency = currency;
    },

    openAddPartner() {
      this.addPartnerModal = true;
    },

    closeAddPartner() {
      this.addPartnerModal = false;
    },

    partnerAdded(newPartner) {
      this.partner = newPartner;

      console.log(this.partner);
    },
  },
  watch: {
    items: {
      handler(newItems) {
        newItems.forEach((newItem) => {
          this.dropOffs.forEach((dropOff) => {
            const itemIndex = dropOff.items.findIndex(
              (dropOffItem) => dropOffItem.id === newItem.id
            );
            if (itemIndex !== -1) {
              this.$set(dropOff.items, itemIndex, newItem);
            }
          });
        });
      },
      deep: true,
    },
    dropOffs: {
      handler() {
        if (this.step === 5) this.doValidaOrder();
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.custom-page >>> .stepper p:nth-child(2) {
  width: 5rem;
  text-align: center;
}

.custom-page >>> .stepper p:nth-child(3) {
  width: 5rem;
  text-align: center;
  margin-right: 0.4rem;
}

.custom-page >>> .stepper p:nth-child(4) {
  width: 5rem;
  text-align: center;
  margin-right: 0.6rem;
}

@media (min-width: 768px) {
  .add-dispatch-container {
    padding: 20px 2rem;
  }
}

@media (min-width: 1600px) {
  .add-dispatch-container {
    padding: 40px 3rem;
  }
}
</style>
